import { getFontSize, getFontWeight } from '../../../foundation/theme/typography.utils';
import tokens from '../../../foundation/tokens/js/tokens';
// Constants.
// -----------------------------------------------------------------------------
/** Default checked */
export const CHECKBOX_DEFAULT_CHECKED = false;
/** Default disabled */
export const CHECKBOX_DEFAULT_DISABLED = false;
/** Default mode. */
export const CHECKBOX_DEFAULT_MODE = 'light';
/** Default role. */
export const CHECKBOX_DEFAULT_ROLE = 'none';
/** Default size. */
export const CHECKBOX_DEFAULT_SIZE = 's';
/** Mapping: mode. */
export const MAPPINGS_MODE = {
    // Dark mode.
    dark: {
        background: tokens.colors.black[100].value,
        border: tokens.colors.midnight[700].value,
        text: tokens.colors.midnight[300].value,
        checked: {
            background: tokens.colors.midnight[100].value,
            border: tokens.colors.midnight[700].value
        },
        disabled: {
            background: tokens.colors.midnight[850].value,
            border: tokens.colors.midnight[800].value,
            text: tokens.colors.midnight[800].value
        },
        focus: {
            border: tokens.colors.midnight[850].value,
            shadow: `0 0 0 4px ${tokens.colors.midnight[150].value}`
        },
        hover: {
            border: tokens.colors.midnight[400].value
        }
    },
    // Light mode.
    light: {
        background: tokens.colors.white[100].value,
        border: tokens.colors.midnight[200].value,
        text: tokens.colors.midnight[800].value,
        checked: {
            background: tokens.colors.midnight[800].value,
            border: tokens.colors.midnight[800].value
        },
        disabled: {
            background: tokens.colors.midnight[150].value,
            border: tokens.colors.midnight[200].value,
            text: tokens.colors.midnight[200].value
        },
        focus: {
            border: tokens.colors.midnight[850].value,
            shadow: `0 0 0 4px ${tokens.colors.midnight[150].value}`
        },
        hover: {
            border: tokens.colors.midnight[400].value
        }
    }
};
/** Scale mappings. */
export const MAPPINGS_SCALE = {
    s: {
        fontSize: getFontSize('s'),
        fontWeight: getFontWeight('medium')
    },
    xs: {
        fontSize: getFontSize('xs'),
        fontWeight: getFontWeight('medium')
    }
};
//# sourceMappingURL=Checkbox.constants.js.map